<section>
  <kendo-grid [data]="orderHeaderGridData"
              class="orderSelectionGridCls"
              [sortable]="true"
              [selectable]="false"
              [navigable]="true"
              [filterable]="true"
              [groupable]="false"
              [reorderable]="true"
              [resizable]="true"
              [sort]="orderGridstate.sort"
              [pageable]="{ buttonCount: 5, info: true, pageSizes:[50,75,100] }"
              [pageSize]="orderGridstate.take"
              [skip]="orderGridstate.skip"
              [columnMenu]="{ filter: false, sort: false }"
              (sort)="orderHeaderGridSortChange($event)"
              (pageChange)="orderHeaderGridPageChange($event)"
              (dataStateChange)="orderHeaderGridDataStateChange($event)"
              [filter]="orderGridSettings.state.filter"
              [loading]="orderLoading">
    <!--(columnReorder)="onReorder($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"-->
    <kendo-grid-column *ngFor="let col of orderGridSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [width]="col._width"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format" media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'orderNumber'">
        <a class="link sample-product-order-number"
           (click)="proceedToOrderDetails(dataItem)">
          {{dataItem.orderNumber}}
        </a>
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </ng-template>
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'orderDate'">
        <span>{{dataItem.orderDate | date: 'MM/dd/yyyy'}}</span>
      </ng-template>
      <!--<ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'orderDate'">-->
      <!--<span> {{dataItem.orderDate}}</span>-->
      <!--<app-grid-daterange-filter class="date-range-filter"
                                 [filter]="filter"
                                 field="orderDate">
      </app-grid-daterange-filter>
    </ng-template>-->
      <ng-template kendoGridCellTemplate let-filter let-column="column" let-dataItem *ngIf="col.field == 'requestDate'">
        <span *ngIf="dataItem.requestDate!='0001-01-01T00:00:00'">{{dataItem.requestDate | date: 'MM/dd/yyyy'}}</span>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate>
    </ng-template>
  </kendo-grid>

</section>


